import { render, staticRenderFns } from "./ColorPickers.vue?vue&type=template&id=2d0cde8b"
import script from "./ColorPickers.vue?vue&type=script&lang=js"
export * from "./ColorPickers.vue?vue&type=script&lang=js"
import style0 from "./ColorPickers.vue?vue&type=style&index=0&id=2d0cde8b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports